export const ORDERS_SUMMARY_REQUEST = 'ORDERS_SUMMARY_REQUEST';
export const ORDERS_SUMMARY_SUCCESS = 'ORDERS_SUMMARY_SUCCESS';
export const ORDERS_SUMMARY_FAIL = 'ORDERS_SUMMARY_FAIL';

export const GET_ORDER_BY_USER_ID_REQUEST = 'GET_ORDER_BY_USER_ID_REQUEST';
export const GET_ORDER_BY_USER_ID_SUCCESS = 'GET_ORDER_BY_USER_ID_SUCCESS';
export const GET_ORDER_BY_USER_ID_FAIL = 'GET_ORDER_BY_USER_ID_FAIL';

